import { Controller } from '@hotwired/stimulus'

// Extend the controller with the interface
export default class extends Controller {
  declare autoDismissValue: boolean
  declare dismissAfterValue: number
  private dismissTimer?: number

  static targets = ['message']
  static values = {
    autoDismiss: { type: Boolean, default: true },
    dismissAfter: { type: Number, default: 5000 },
  }

  connect() {
    if (this.autoDismissValue) {
      this.dismissTimer = window.setTimeout(() => {
        this.dismiss()
      }, this.dismissAfterValue)
    }
  }

  disconnect() {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer)
    }
  }

  dismiss() {
    this.element.classList.add('tw-opacity-0', 'tw-transition-opacity')
    setTimeout(() => {
      this.element.remove()
    }, 150)
  }
}
